import React from 'react';
import Modal from '@material-ui/core/Modal';
import { Button, DialogContent } from '@material-ui/core';

// Componente modal reutilizable con botón disparador interno
// Comentario: ahora acepta props para estilizar el botón y deshabilitarlo según necesidad
export default function ModalStandart({ className, text, body, onClose, handleDiasDisponibles = () => {}, handleFilter = () => {}, disabled = false, variant = 'contained', color = 'primary' }){
  const [open, setOpen] = React.useState(false); // Estado de apertura del modal

  const handleOpen = () => {
    setOpen(true); // Abrimos el modal
    handleDiasDisponibles(); // Ejecutamos callback opcional al abrir
    handleFilter && handleFilter(); // Ejecutamos filtro si fue provisto
  };

  const handleClose = () => {
    setOpen(false); // Cerramos el modal
    onClose && onClose(); // Disparamos callback de cierre si existe
  };

  return (
    <div>
      {/* Botón disparador del modal; ahora soporta variant/color/disabled y estilos externos */}
      <Button className={className} type="button" style={{ fontWeight: 'bold', width: '100%' }} onClick={handleOpen} variant={variant as any} color={color as any} disabled={disabled}>
        {text}
      </Button>
      {/* Contenedor del modal centrado en pantalla */}
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <>
        {/* Área scrollable del contenido para evitar desbordes en pantallas pequeñas */}
        <DialogContent style={{ maxHeight: '80vh', overflowY: 'auto' }}>
         {body(handleClose)} {/* Render prop: el cuerpo recibe handleClose para cerrar desde dentro */}
        </DialogContent>
        </>
      </Modal>
    </div>
  );
}

